// The "large model" threshold — above these, the GoJS diagram is deferred and
// the model opens in the headless list view (VET-6943). The single change-point.
export const CLASSES_MAX_LIMIT = 400;
export const PROPERTIES_MAX_LIMIT = 400;

export type ModelSizes = {
  classes: number;
  properties: number;
};

export const isLargeModelSize = ({
  classes,
  properties,
}: ModelSizes): boolean =>
  classes > CLASSES_MAX_LIMIT || properties > PROPERTIES_MAX_LIMIT;

// Accepts PendingModelData or ProjectModel (both carry classes/properties).
export const getPendingModelDataSizes = (
  modelData: Record<
    string,
    {
      classes?: Record<string, unknown> | null;
      properties?: Record<string, unknown> | null;
      [key: string]: unknown;
    }
  >
): ModelSizes => {
  const models = Object.values(modelData);
  return {
    classes: models.reduce(
      (total, data) =>
        total + (data.classes ? Object.keys(data.classes).length : 0),
      0
    ),
    properties: models.reduce(
      (total, data) =>
        total + (data.properties ? Object.keys(data.properties).length : 0),
      0
    ),
  };
};
